import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=10952c1b&scoped=true"
import script from "./AccountSettings.vue?vue&type=script&lang=ts"
export * from "./AccountSettings.vue?vue&type=script&lang=ts"
import style0 from "./AccountSettings.vue?vue&type=style&index=0&id=10952c1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10952c1b",
  null
  
)

export default component.exports